"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewrelicReporter = void 0;
const typeGuard_1 = require("./typeGuard");
class NewrelicReporter {
    constructor() {
        this.type = 'reporting';
        this.logger = {
            warn: () => { },
            info: () => { },
            debug: () => { },
            trace: () => { },
            fatal: this.log.bind(this),
            error: this.log.bind(this),
        };
    }
    setConfig(config) {
        this.config = config;
    }
    static shouldIgnoreError(err) {
        return NewrelicReporter.ignoreErrorMessages.some((regex) => regex.test(err.message));
    }
    getAppUniqueNameByAppName(appName) {
        var _a;
        const appConfig = (_a = this.config) === null || _a === void 0 ? void 0 : _a.getConfigForAppByName(appName);
        if (appConfig && appConfig.props) {
            const appProps = appConfig.props;
            return appProps.boundedContext;
        }
        return undefined;
    }
    getAppNameByBundle(bundlePath) {
        var _a;
        const apps = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.getConfigForApps()) || {};
        return Object.keys(apps).find((appName) => {
            const appConfig = apps[appName];
            return appConfig.spaBundle === bundlePath;
        });
    }
    getSharedLibNameByBundle(bundlePath) {
        var _a;
        const sharedLibs = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.getConfigForSharedLibs()) || {};
        return Object.keys(sharedLibs)
            .find((libName) => sharedLibs[libName] === bundlePath);
    }
    getAdditionalAttribtues(error) {
        const { errorId, code } = error;
        const errorInfo = {
            code,
            errorId,
            ...error.data,
        };
        if (errorInfo.dependants && (0, typeGuard_1.isStringArray)(errorInfo.dependants)) {
            errorInfo.dependants = errorInfo.dependants.map((dependant) => {
                const appName = this.getAppNameByBundle(dependant);
                const sharedLibName = this.getSharedLibNameByBundle(dependant);
                return appName || sharedLibName || dependant;
            });
        }
        if (!errorInfo.name && errorInfo.src) {
            const name = this.getAppNameByBundle(errorInfo.src);
            Object.assign(errorInfo, name ? { name } : {});
        }
        if (errorInfo.name) {
            const uniqueName = this.getAppUniqueNameByAppName(errorInfo.name);
            Object.assign(errorInfo, uniqueName ? { serviceName: uniqueName } : {});
        }
        return errorInfo;
    }
    log(msg, logInfo) {
        if (!window.newrelic || !window.newrelic.noticeError) {
            return;
        }
        if (!logInfo) {
            return;
        }
        if (!(0, typeGuard_1.isIlcError)(logInfo) && !(0, typeGuard_1.isError)(logInfo)) {
            return;
        }
        if (NewrelicReporter.shouldIgnoreError(logInfo)) {
            return;
        }
        const customAttributes = {};
        if ((0, typeGuard_1.isIlcError)(logInfo)) {
            Object.assign(customAttributes, this.getAdditionalAttribtues(logInfo));
        }
        window.newrelic.noticeError(logInfo, customAttributes);
    }
}
exports.NewrelicReporter = NewrelicReporter;
NewrelicReporter.ignoreErrorMessages = [
    /^Application '.+?' died in status LOADING_SOURCE_CODE: Failed to fetch$/,
];
